/**
 * Pricing Feature i18n Registration
 * 定价功能国际化注册
 *
 * 将pricing的多语言文本注册到全局i18n系统
 */

import { addLocaleMessages } from '@/i18n';
import { zhCN, enUS, jaJP, zhTW } from './locales';

/**
 * 注册pricing feature的多语言文本
 */
export function registerPricingI18n() {
    // 注册简体中文
    addLocaleMessages('cn', {
        pricing: zhCN,
    });

    // 注册英文
    addLocaleMessages('en', {
        pricing: enUS,
    });

    // 注册日文
    addLocaleMessages('jp', {
        pricing: jaJP,
    });

    // 注册繁体中文
    addLocaleMessages('tw', {
        pricing: zhTW,
    });
}

// 自动注册（模块导入时执行）
registerPricingI18n();
